require('./bootstrap');
const Swal = require('sweetalert2')

let page = document.querySelector('.page-subscription');

if (page) {

    // set limit date on birthday field
    document.querySelectorAll('.birthdate-field').forEach(element => {
        element.setAttribute('max', dateLimit);
    });

    form_team.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        let btn = document.querySelector('[data-action="save-team"]');
        btn.setAttribute('disabled', true);
        btn.innerHTML = 'Attendi ...';

        if (!form_team.checkValidity()) {
            form_team.classList.add('was-validated');

            btn.removeAttribute('disabled');
            btn.innerHTML = 'AGGIORNA SQUADRA';

        } else {
            const formData = new FormData(form_team);
            const data = Object.fromEntries(formData.entries());

            const route = basePath + '/teams';
            if (data.id) {
                route = basePath + '/teams/' + data.id
            }

            axios
                .post(route, {
                    data: data
                })
                .then(function (response) {
                    Swal.fire({
                        icon: 'success',
                        title: 'La tua squadra è stata aggiornata!',
                        showCancelButton: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload();
                        }
                    });
                })
                .catch(function (error) {
                    btn.setAttribute('disabled', false);
                    btn.innerHTML = 'AGGIORNA SQUADRA';
                });
        }
    });


    let selectNumberPlayers = document.querySelector('.select_number_players');
    let rowDb = document.querySelectorAll('.row_db');

    let blockPlayer = `
        <input type="hidden" name="players-#ID#-certificate" value="0" />
        <tr class="row_html">
            <td data-title="Nome"><input type="text" class="form-control" name="players-#ID#-first_name"></td>
            <td data-title="Cognome"><input type="text" class="form-control" name="players-#ID#-last_name"></td>
            <td data-title="Data nascita"><input type="date" max="${dateLimit}" class="form-control birthdate-field" name="players-#ID#-birth_date"></td>
            <td data-title="Luogo nascita"><input type="text" class="form-control" name="players-#ID#-birth_place"></td>
            <td data-title="Sesso"><select class="form-select" aria-label="Default select example" name="players-#ID#-sex">
                    <option value="">-- Seleziona --</option>
                    <option value="M">Maschio</option>
                    <option value="F">Femmina</option>
                </select></td>`;

        if (window.HAVE_GADGET) {
            blockPlayer += `<td data-title="Taglia Gadget"><select class="form-select" aria-label="Default select example" name="players-#ID#-size_gadget">
                <option value="" selected="selected">-- Seleziona --</option>`;
            window.GADGET_VARIANTS.forEach((v, i) => {
                blockPlayer += `<option>` + v + `</option>`;
            });

            blockPlayer += `</select></td>`;
        }

        blockPlayer +=
        `<td data-title="Socio"><select class="form-select" aria-label="Default select example" name="players-#ID#-partner">
                <option value="0" selected="selected">No</option>
                <option value="1">Si</option>
            </select></td>
        </tr>
    `;
    const event = new Event('change');

    selectNumberPlayers.addEventListener('change', (el) => {
        var selectElement = el.target;
        var numberPlayersTotal = selectElement.value;
        let rowHtml = document.querySelectorAll('.row_html');

        // leggi il numero di elementi gia creati con classe "db" per aggiungere solo quelli mancanti, se sono meno colorali di rosso

        let diff = numberPlayersTotal - rowDb.length;

        rowDb.forEach(element => {
            element.classList.remove('to_remove');
        });
        rowHtml.forEach(element => {
            element.remove();
        });


        // colora di rosso righe in più
        if (diff < 0) {
            for(let i = numberPlayersTotal; i < rowDb.length; i ++) {
                rowDb[i].classList.add('to_remove');
            }
        }
        // aggiungi elementi
        else {
            for(let i = 0; i < diff; i ++) {
                blockPlayerId = blockPlayer.replaceAll('#ID#', (rowDb.length + i + 1))
                document.querySelector('.players_table').insertAdjacentHTML('beforeend', blockPlayerId);
            }
        }
    });

    selectNumberPlayers.dispatchEvent(event);
}

